const FetchNotificationsReducer = (state = { type: 'LOADING_FETCH_NOTIFICATIONS_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_FETCH_NOTIFICATIONS_ACTION':
            return action
        default:
            return state
    }
}

const UpdateSubscribeReducer = (state = { type: 'LOADING_UPDATE_SUBSCRIBE_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_UPDATE_SUBSCRIBE_ACTION':
            return action
        default:
            return state
    }
}

const ReadNotificationReducer = (state = { type: 'LOADING_READ_NOTIFICATION_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_READ_NOTIFICATION_ACTION':
            return action
        default:
            return state
    }
}

const ReadAllNotificationReducer = (state = { type: 'LOADING_READ_ALL_NOTIFICATION_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_READ_ALL_NOTIFICATION_ACTION':
            return action
        default:
            return state
    }
}

export {
    UpdateSubscribeReducer,
    FetchNotificationsReducer,
    ReadNotificationReducer,
    ReadAllNotificationReducer
}